import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { UserSettingController } from '@shared/src/controllers/user/usersetting.controller';
import { HColor } from '@shared/src/datatypes/HColor';
import { HString } from '@shared/src/datatypes/HString';
import { PortAddressController, PortAddressOriginDestinationClassificationItemDTO, PortAddressOriginDestinationClassificationDTO, PortAddressItemSelectorDto } from '@shared/src/controllers/portaddress/port.address.controller';

@Component({
  selector: 'shared-port-address-origin-destination-selector-component',
  templateUrl: './shared.port.address.origin.destination.selector.component.html',
  styleUrls: ['./shared.port.address.origin.destination.selector.component.scss']
})

/***
 * Encapçula dues llistes d'adreces portuaries, les de origen i les de destí, de moment, les dues llistes son iguales
 */
export class SharedPortAddressOriginDestinationSelectorComponent implements OnInit {

  private PARAMETERORIGINIDNAME = "originId";
  private PARAMETERDESTINATIONIDNAME = "destinationId";

  constructor(private activatedRoute: ActivatedRoute, private userSettingController: UserSettingController, private portAddressController: PortAddressController, private homeController: HomeController) {
  }

  ngOnInit(): void {

    const routeParams = this.activatedRoute.snapshot.paramMap;
    const queryParams = this.activatedRoute.snapshot.queryParamMap;


    let origin = routeParams.has(this.PARAMETERORIGINIDNAME) ? routeParams.get(this.PARAMETERORIGINIDNAME) : queryParams.get(this.PARAMETERORIGINIDNAME);
    if (origin) {
      this.originId = +origin;
    } else {
    }
    let destination = routeParams.has(this.PARAMETERDESTINATIONIDNAME) ? routeParams.get(this.PARAMETERDESTINATIONIDNAME) : queryParams.get(this.PARAMETERDESTINATIONIDNAME);
    if (destination) {
      this.destinationId = +destination;
    } else {
    }

  }

  public searchTextDestination: string = "";
  public searchTextOrigin: string = "";
  public sliceCount: number = 3;

  @Output() changeValues = new EventEmitter<PortAddressOriginDestinationSelectorDto>();

  private __value: PortAddressOriginDestinationSelectorDto;
  @Input()
  public set value(value: PortAddressOriginDestinationSelectorDto) {
    if (this.__value === value)
      return;
    this.__value = value;

    if (this.__value) {
      if (!HString.isNullOrNullString(this.classification)) {
        this.load();
      } else
        this.loadOriginsDestinationsSelector();
    }
  }
  public get value(): PortAddressOriginDestinationSelectorDto {
    return this.__value;
  }

  private isLoadedFull: boolean = false;
  public load() {
    this.portAddressController.getOriginDestinationClassification(this.classification, "nofull").subscribe(data => {
      this.isLoadedFull = false;
      this.data = data;
      this.loadOrigins(data, false, true);
      this.loadDestinations(data, false, true);
      this.changeValues.next(this.value);
    });
  }
  public loadFull() {
    this.portAddressController.getOriginDestinationClassification(this.classification, "full").subscribe(data => {
      this.isLoadedFull = false;
      this.data = data;
      this.loadOrigins(data, false, true);
      this.loadDestinations(data, false, true);
      this.changeValues.next(this.value);
    });
  }


  public loadOriginsDestinationsSelector() {

    if (this.originsTots)
      this.selectOrigin(this.originsTots.find(x => { return x.portAddressId == this.selectedOriginId }), false, true);
    if (this.destinationTots)
      this.selectDestination(this.destinationTots.find(x => { return x.portAddressId == this.selectedDestinationId }), false, true);

    this.changeValues.next(this.value);
  }

  @Input()
  public set destinationId(value: number) {
    if (this.value)
      this.value.destinationId = value;
  }
  public get destinationId() {
    if (this.value)
      return this.value.destinationId;
    return 0;
  }

  public get classification() {
    if (this.value)
      return this.value.classification;
    return "";
  }

  @Input()
  public set originId(value: number) {
    if (this.value)
      this.value.originId = value;
  }
  public get originId() {
    if (this.value)
      return this.value.originId;
    return 0;
  }

  public get showOrigins() {
    if (this.value)
      return this.value.showOrigins;
    return false;
  }

  public get showDestinations() {
    if (this.value)
      return this.value.showDestinations;
    return false;
  }

  public get maxOrigins() {
    if (this.value)
      return this.value.maxOrigins;
    return 0;
  }

  public get maxDestinations() {
    if (this.value)
      return this.value.maxDestinations;
    return 0;
  }

  public get canunsetdestination() {
    if (this.value)
      return this.value.canunsetdestination;
    return false;
  }

  public getDestinationsToolTip(a: PortAddressItemSelectorDto): string {
    if (a == null)
      return "";
    return a.addressKey + " " + a.description;
  }

  public getOriginToolTip(a: PortAddressItemSelectorDto): string {
    if (a == null)
      return "";
    return a.addressKey + " " + a.description;
  }


  public data: PortAddressOriginDestinationClassificationDTO;
  public originsBarra: Array<PortAddressItemSelectorDto>;
  public originsMenu: Array<PortAddressItemSelectorDto>;
  public originsTots: Array<PortAddressItemSelectorDto>;
  public destinationBarra: Array<PortAddressItemSelectorDto>;
  public destinationMenu: Array<PortAddressItemSelectorDto>;
  public destinationTots: Array<PortAddressItemSelectorDto>;
  public selectedDestinationId: number;
  public selectedOriginId: number;
  public menuOriginsObert: boolean = false;
  public menuDestinationsObert: boolean = false;
  public originsAddicionals: number;
  public destinationAddicionals: number;
  public seleccionatMenuMesDestinations: boolean = false;
  public seleccionatMenuMesOrigin: boolean = false;

  /***
   * Es prepara les dades per tal de mostrar la pantalla. FA la part d0'origins
   */
  loadOrigins(data: PortAddressOriginDestinationClassificationDTO, perPantalla: boolean, avoidChangeValues: boolean) {
    this.originsBarra = new Array<PortAddressItemSelectorDto>();
    this.originsMenu = new Array<PortAddressItemSelectorDto>();
    this.originsTots = new Array<PortAddressItemSelectorDto>();
    if (data == null || data.originList == null) {
      this.changeValues.next(this.value);
      return;
    }

    this.fix(data.originList);

    //No cal ordenar-los però si que calculo forecolor i backcolor per ser més ràpid després i sobretot si es mostra a barra o a llista
    let i = 0;
    data.originList.sort(this.portAddressController.comparePortAddress).reverse().forEach(a => {
      let dto = PortAddressItemSelectorDto.build(a, i < this.maxOrigins, this.homeController);
      if (i++ < this.maxOrigins)
        this.originsBarra.push(dto);
      else
        this.originsMenu.push(dto);
      this.originsTots.push(dto);
    });

    if (this.originsMenu.length > 0)
      this.originsMenu.unshift(this.originsBarra.pop());
    this.originsAddicionals = this.originsMenu.length;

    let propostaOrigin = data.defaultOriginId;
    if (this.originId && this.originId != 0)
      propostaOrigin = this.originId;

    this.selectOrigin(this.originsTots.find(x => { return x.portAddressId == propostaOrigin }), perPantalla, avoidChangeValues);

  }

  loadDestinations(data: PortAddressOriginDestinationClassificationDTO, perPantalla: boolean, avoidChangeValues: boolean) {
    this.destinationBarra = new Array<PortAddressItemSelectorDto>();
    this.destinationMenu = new Array<PortAddressItemSelectorDto>();
    this.destinationTots = new Array<PortAddressItemSelectorDto>();
    if (data == null || data.destinationList == null) {
      this.changeValues.next(this.value);
      return;
    }
    this.fix(data.destinationList);

    //No cal ordenar-los però si que calculo forecolor i backcolor per ser més ràpid després i sobretot si es mostra a barra o a llista
    let i = 0;
    data.destinationList.sort(this.portAddressController.comparePortAddress).reverse().forEach(a => {
      let dto = PortAddressItemSelectorDto.build(a, i < this.maxDestinations, this.homeController);
      if (i++ < this.maxDestinations)
        this.destinationBarra.push(dto);
      else
        this.destinationMenu.push(dto);
      this.destinationTots.push(dto);
    });

    if (this.destinationMenu.length > 0)
      this.destinationMenu.unshift(this.destinationBarra.pop());
    this.destinationAddicionals = this.destinationMenu.length;

    let propostaDestination = data.defaultDestinationId;
    if (this.destinationId && this.destinationId != 0)
      propostaDestination = this.destinationId;

    this.selectDestination(this.destinationTots.find(x => { return x.portAddressId == propostaDestination }), perPantalla, avoidChangeValues);

  }
  fix(originalList: PortAddressOriginDestinationClassificationItemDTO[]) {
    let i = 0;
    while (i < originalList.length) {
      let item = originalList[i];
      item.skinToShow = item.skin.replace("-", " ");

      const [country, port] = item.skin.split('-');
      item.country = country;
      item.port = port;
      i++;
    }
  }


  obrirMenuOrigins() {
    this.menuOriginsObert = !this.menuOriginsObert;
    this.loadFull();
  }
  obrirMenuDestinations() {
    this.menuDestinationsObert = !this.menuDestinationsObert;
    this.loadFull();
  }
  selectScreenOrigin(item: PortAddressItemSelectorDto) {

    if (item != null && item.portAddressId === this.originId) {
      this.originId = 0;

      if (this.value && this.value.classification) {
        this.selectOrigin(null, true, false);
      } else {
        this.userSettingController.setDefaultPortAddressOriginId(this.originId).subscribe(data => {
          this.selectOrigin(null, true, false);
        });
      }
      return;
    }

    this.originId = item != null ? item.portAddressId : 0;
    if (this.value && this.value.classification) {
      this.selectOrigin(item, true, false);
    } else {
      this.userSettingController.setDefaultPortAddressOriginId(this.originId).subscribe(data => {
        this.selectOrigin(item, true, false);
      });
    }

  }

  selectOrigin(item: PortAddressItemSelectorDto, perPantalla: boolean, avoidChangeValues: boolean) {
    let proposta = item != null && item != undefined ? item.portAddressId : 0;
    if (this.originId && this.originId != 0)
      proposta = this.originId;
    if (proposta === this.selectedOriginId) {
      if (perPantalla)
        this.changeValues.next(this.value);
      return;
    }
    this.selectedOriginId = proposta;
    this.menuOriginsObert = false;
    this.seleccionatMenuMesOrigin = false;

    this.originsMenu.forEach(i => { this.seleccionatMenuMesOrigin = this.seleccionatMenuMesOrigin || i.portAddressId == this.selectedOriginId });

    this.__value.origin = item;
    this.__value.originId = item != null ? item.portAddressId : 0;

    this.actualitzarClassification(perPantalla, this.selectedOriginId, this.selectedDestinationId, avoidChangeValues);

  }

  selectScreenDestination(item: PortAddressItemSelectorDto) {

    if (item != null && item.portAddressId === this.destinationId) {
      this.destinationId = 0;

      if (this.value && this.value.classification) {
        this.selectDestination(null, true, false);
      } else {
        this.userSettingController.setDefaultPortAddressDestinationId(this.destinationId).subscribe(data => {
          this.selectDestination(null, true, false);
        });
      }
      return;
    }

    this.destinationId = item != null ? item.portAddressId : 0;
    if (this.value && this.value.classification) {
      this.selectDestination(item, true, false);
    } else {
      this.userSettingController.setDefaultPortAddressDestinationId(this.destinationId).subscribe(data => {
        this.selectDestination(item, true, false);
      });
    }
  }

  selectDestination(item: PortAddressItemSelectorDto, perPantalla: boolean, avoidChangeValues: boolean) {
    let proposta = item != null && item != undefined ? item.portAddressId : 0;
    if (this.destinationId && this.destinationId != 0)
      proposta = this.destinationId;
    if (proposta === this.selectedDestinationId) {
      if (perPantalla)
        this.changeValues.next(this.value);
      return;
    }
    this.selectedDestinationId = proposta;
    this.menuDestinationsObert = false;
    this.seleccionatMenuMesDestinations = false;

    this.destinationMenu.forEach(i => { this.seleccionatMenuMesDestinations = this.seleccionatMenuMesDestinations || i.portAddressId == this.selectedDestinationId });

    this.__value.destination = item;
    this.__value.destinationId = item != null ? item.portAddressId : 0;

    this.actualitzarClassification(perPantalla, this.selectedOriginId, this.selectedDestinationId, avoidChangeValues);
  }

  public actualitzarClassification(perPantalla: boolean, originId: number, destinationId: number, avoidChangeValues: boolean) {
    if (!perPantalla) {
      if (!avoidChangeValues)
        this.changeValues.next(this.value);
      return;
    }
    if (this.value && this.value.classification) {
      this.data.defaultOriginId = originId;
      this.data.defaultDestinationId = destinationId;
      if (!avoidChangeValues)
        this.changeValues.next(this.value);
      this.portAddressController.setOriginDestinationClassification(this.value.classification, this.data.defaultOriginId, this.data.defaultDestinationId).subscribe(data => {

      });
    }
  }

  public pretty(value: any): string {
    return JSON.stringify(value);
  }
}


export class PortAddressOriginDestinationSelectorDto {

  public classification: string;

  public originId: number;
  public origin: PortAddressItemSelectorDto;
  public destinationId: number;
  public destination: PortAddressItemSelectorDto;
  public showOrigins: boolean = true;
  public showDestinations: boolean = true;
  public canunsetdestination: boolean;
  public maxOrigins: number = 6;
  public maxDestinations: number = 6;

  public static buildActiveBookings(): PortAddressOriginDestinationSelectorDto {
    let dto: PortAddressOriginDestinationSelectorDto = new PortAddressOriginDestinationSelectorDto();
    dto.classification = "activeBookings";
    dto.canunsetdestination = true;
    return dto;
  }


  public setClassification(classification: string): PortAddressOriginDestinationSelectorDto {
    this.classification = classification;
    return this;
  }

}

